import {FC} from "react";
import {Trans, useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader} from "@interstate/components/Card";
import "./SummaryCard.scss";

export interface SummaryCardProps {
  baseLabelKey: string;
  qualifier: string;
  count: number;
  name?: string;
}

export const SummaryCard: FC<SummaryCardProps> = ({
  baseLabelKey,
  qualifier,
  count,
  name
}) => {
  const {t} = useTranslation();
  return (
    <Card
      id={`create-organization-${qualifier}-summary-card`}
      data-testid={`create-organization-${qualifier}-summary-card`}
      className={`create-organization-summary-card create-organization-${qualifier}-summary-card`}
      header={
        <CardHeader
          title={t(
            `${baseLabelKey}.${qualifier}.title`,
            name ? {tenantName: name} : undefined
          )}
        />
      }
      content={
        <CardContent>
          <Trans
            i18nKey={`${baseLabelKey}.${qualifier}.content`}
            values={{count, name}}
            components={{bold: <strong className={"summary-card-count"} />}}
          />
        </CardContent>
      }
    />
  );
};
